
import React from 'react';
import { GraduationCap, Brain, CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface LearningHeaderProps {
  enrolledCoursesCount: number;
  totalXp: number;
}

const LearningHeader: React.FC<LearningHeaderProps> = ({ 
  enrolledCoursesCount, 
  totalXp 
}) => {
  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
      <div>
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <GraduationCap className="h-8 w-8 text-primary" />
          Artist Academy
        </h1>
        <p className="text-muted-foreground">Learn, grow, and master your craft</p>
      </div>
      
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1.5">
          <div className="flex items-center gap-1 bg-primary/10 px-2 py-1 rounded-md">
            <Brain className="h-4 w-4 text-primary" />
            <span className="text-sm font-medium">{totalXp} XP</span>
          </div>
          <div className="flex items-center gap-1 bg-green-500/10 px-2 py-1 rounded-md">
            <CheckCircle className="h-4 w-4 text-green-500" />
            <span className="text-sm font-medium">{enrolledCoursesCount} Courses</span>
          </div>
        </div>
        <Button size="sm" variant="outline">Learning Stats</Button>
      </div>
    </div>
  );
};

export default LearningHeader;
